import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(public authService: AuthService, public router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticatedAsync().then((validUser) => {
      if (validUser) {
        return true;
      } else {
        localStorage.clear();
        if (state.url && state.url === '/taxes') {
          this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
        } else {
          this.router.navigate(['login']);
        }
        return false;
      }
    }).catch(() => {
      localStorage.clear();
      this.router.navigate(['login']);
      return false;
    });
  }
}
